export default "__VITE_ASSET__CEnUSLMg__"